import React from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import Brand from '../../menhomethree/Brand'
import First from '../menhealthcampusgallery/First'

function Main() {
  return (
    <>
        <Header/>
        <Bredcom title="Home" subtitle="Health Camps / Industrial Visits"/>
        <First/>
        {/* <Brand/> */}
    </>
  )
}

export default Main